import { render, staticRenderFns } from "./resourceManageDialog.vue?vue&type=template&id=6075db6b&scoped=true"
import script from "./resourceManageDialog.vue?vue&type=script&lang=js"
export * from "./resourceManageDialog.vue?vue&type=script&lang=js"
import style0 from "./resourceManageDialog.vue?vue&type=style&index=0&id=6075db6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075db6b",
  null
  
)

export default component.exports